/**
 * RedirectWithParams Component
 * TASK-398: Route Consolidation
 *
 * Utility component that redirects old meeting routes to new ones,
 * preserving URL parameters (e.g., meetingId).
 *
 * TASK-400 C6.3: guards against missing route params. If any `:param` in the
 * target is missing from the current URL, fall back to /dashboard instead of
 * generating a broken target like `/data-gathering/` that produces a blank page.
 */

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { logger } from '../../utils/logger';

interface RedirectWithParamsProps {
  to: string;
}

const RedirectWithParams: React.FC<RedirectWithParamsProps> = ({ to }) => {
  const params = useParams();
  let missingParam = false;
  const target = to.replace(/:(\w+)/g, (_, key) => {
    const value = params[key];
    if (!value) {
      missingParam = true;
      return '';
    }
    return value;
  });

  if (missingParam) {
    logger.warn(`RedirectWithParams: missing route param for target "${to}"`);
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to={target} replace />;
};

export default RedirectWithParams;
